import Vue from 'vue'
import App from './App.vue'
const cors = require('cors');

import Dexie from "dexie";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import store from "./store";
import router from "./router";
import "@/styles/index.scss"; // global css
import locale from 'element-ui/lib/locale';
import enLocale from 'element-ui/lib/locale/lang/en'; // Element UI 英文语言包
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'; // Element UI 中文语言包
import fanLocale from 'element-ui/lib/locale/lang/zh-TW'; // Element UI 繁体语言包
import en from './lang/en.js';
import zh from './lang/zh';
import fan from './lang/fan';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
// import { registerMicroApps, start } from 'qiankun';

// registerMicroApps([
//   {
//     name: 'react app', // app name registered
//     entry: 'http://10.0.3.187:9528/',
//     container: '/login',
//     activeRule: '/nextApp',
//   }

// ]);

// start();
// import { initGlobalState } from 'qiankun';






const messages = {
  en: { ...enLocale, ...en },
  zh: { ...zhLocale, ...zh },
  fan: { ...fanLocale, ...fan }
};



let i18n = new VueI18n({
  locale: localStorage.getItem("language")|| 'zh', // set default locale
  messages // set locale messages
});
if(localStorage.getItem("language")){

}else{
  localStorage.setItem("language","zh")
}

// localStorage.setItem('locale', 'zh');
locale.i18n((key, value) => i18n.t(key, value)); // 兼容 Element UI 的语言包

Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) });


import { initGlobalState, MicroAppStateActions,loadMicroApp } from 'qiankun';


// 初始化 state
const actions = initGlobalState({type:111,message:"login",router:""});

actions.onGlobalStateChange((state, prev) => {
console.log(state.message,state.router)
  if(state.message=="logout"){
    console.log("子应用退出登录");
    store.dispatch("user/logout");
    actions.setGlobalState({message:"login",router:process.env.VUE_APP_MAIN})
  }

  // if(state.router==process.env.VUE_APP_MAIN&&state.message=="login"){
    
  //   console.log("返回主应用");
  //   window.location.href = "http://10.0.3.178:9530/saas_main/#/";
  //   // if(window.iframeSystem){
  //   //   window.iframeSystem.unmount()
  //   // }
  
  //   // actions.setGlobalState({message:"login",router:process.env.VUE_APP_MAIN})
  // }
  // if(state.router!=process.env.VUE_APP_MAIN&&state.message=="login"&&state.router!=""){
  //   if(window.iframeSystem){
  //     window.iframeSystem.unmount()
  //   }
  //   console.log("切换子应用",state, prev);
  //   loadMicroApp({
  //     name: "阳光智慧娱乐商户平台",
  //     entry: state.router + "/",
  //     container: "#app",
  //   });
  //   actions.setGlobalState({message:"login",router:process.env.VUE_APP_MAIN})
  // }
  
 
},true);

// actions.offGlobalStateChange();

// Vue.use(cors(

// ))
Vue.config.productionTip = false

new Vue({
  i18n,
  render: h => h(App),
  router,
  store,
}).$mount('#app')
